import { DataLineageDiagramUIModel, DataLineageUINode } from '@y42/data-lineage/diagram';

export const getMultipleAssetDependencies = (itemIds: string[], fullModel: DataLineageDiagramUIModel) => {
  return itemIds.map((id) => getSingleAssetDependencies(id, fullModel));
};

const getSingleAssetDependencies = (
  itemId: string,
  fullModel: DataLineageDiagramUIModel,
): { mainAssetPath: string; upstream: string[]; downstream: string[] } => {
  const item = fullModel.nodeDataArray.find((node) => node.key === itemId);
  if (!item) {
    return {
      mainAssetPath: itemId,
      upstream: [],
      downstream: [],
    };
  }

  return {
    mainAssetPath: itemId,
    upstream: getDependency(item, 'upstream', fullModel),
    downstream: getDependency(item, 'downstream', fullModel),
  };
};

const getDependency = (
  node: DataLineageUINode,
  dependencyType: 'upstream' | 'downstream',
  fullModel: DataLineageDiagramUIModel,
) => {
  const deps: string[] = [];

  const addNodeKey = (x: DataLineageUINode, includeKey = true) => {
    if (includeKey) {
      deps.push(x.key);
    }

    if (dependencyType === 'upstream') {
      const nodeKeysInto = fullModel.linkDataArray.filter((link) => link.to === x.key).map((link) => link.from);
      nodeKeysInto.forEach((into) => {
        const foundNodeData = fullModel.nodeDataArray.find((n) => n.key === into);
        if (foundNodeData) {
          addNodeKey(foundNodeData);
        }
      });
    } else if (dependencyType === 'downstream') {
      const nodeKeysOutOf = fullModel.linkDataArray.filter((link) => link.from === x.key).map((link) => link.to);
      nodeKeysOutOf.forEach((outOf) => {
        const foundNodeData = fullModel.nodeDataArray.find((n) => n.key === outOf);
        if (foundNodeData) {
          addNodeKey(foundNodeData);
        }
      });
    }
  };

  addNodeKey(node, false);

  return deps;
};
